import { render, staticRenderFns } from "./ViewUnitOfMeasurePage.vue?vue&type=template&id=4f7852be"
import script from "./ViewUnitOfMeasurePage.vue?vue&type=script&lang=js"
export * from "./ViewUnitOfMeasurePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports